module.exports = __webpack_public_path__ + "static/media/Stock.a65a3474.svg";